import { Skeleton } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const CustomCopySkeleton = () => (
  <Styles.Container>
    <Styles.CopyHeader>
      <Styles.CopyTitleContainer>
        <Skeleton variant="text" width="40%" height={16} />
        <Skeleton variant="rounded" width={240} height={24} />
      </Styles.CopyTitleContainer>
    </Styles.CopyHeader>
    <Styles.DefaultText>
      <Skeleton variant="text" width="90%" height={20} />
    </Styles.DefaultText>
  </Styles.Container>
)

export default CustomCopySkeleton
